<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { authComputed } from "@/state/helpers";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";

import Drawer from "@/components/drawer";
import VueDropify from "vue-dropify";
import MultiSelect from "vue-multiselect";
import Swal from "sweetalert2";
import GXPService from "@/helpers/APIService/gxp.service";

export default {
  components: {
    VueDropify,
    MultiSelect,
    Drawer,
  },
  data() {
    return {
      lightBoxs: [],
      lightBox: {
        name: null,
        page_to_display: null,
        page_to_display_type: null,
        click_open_page: null,
        click_open_page_type: null,
        after_second_display: 0,
        is_one_time_display: 1,
        is_mandatory: 1,
        is_active: 1,
        image: null,
      },
      imgUrl: null,
      submitted: false,
      isBtnLoading: false,
      pageOptions: [],
      openPageOptions: [],
      isLoading: false,
      isBoxDrawerOpen: false,
      isEdit: false,
      boxId: null,
    };
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted"],
  computed: {
    ...authComputed,
  },
  validations: {
    lightBox: {
      name: {
        required,
      },
      page_to_display: {
        required,
      },
      click_open_page: {
        required,
      },
      image: requiredIf(function () {
        if (this.imgURL === null || this.lightBox.image == null) {
          return true;
        }
      }),
    },
  },
  mounted() {
    this.setIfEdit();
    this.$root.$on("addNewLightBox", (data) => {
      this.addNewLightBox();
    });
  },
  methods: {
    // Method is use for set data on edit
    setIfEdit() {
      if (
        this.currentProps.lightBoxPageOptions !== null &&
        this.currentProps.lightBoxPageOptions !== undefined
      ) {
        this.pageOptions = this.currentProps.lightBoxPageOptions;
        this.openPageOptions = this.currentProps.openPageOptions;
      }
      let filter = "";
      if (this.currentProps.selectedPage !== undefined) {
        filter += `?page_to_display=${this.currentProps.selectedPage}`;
      }
      this.isLoading = true;
      GXPService.getLightBox(filter)
        .then((response) => {
          this.lightBoxs = response;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          errorHandler(error);
        });
    },
    // Method is use for submit data
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        const lightBoxData = new FormData();
        if (this.imgUrl !== null && this.imgUrl !== undefined) {
          lightBoxData.append("image", this.imgUrl);
        }
        lightBoxData.append("hotel", this.hotel.id);
        delete this.lightBox.image;
        this.lightBox.click_open_page_type = this.lightBox.click_open_page.type;
        this.lightBox.page_to_display_type = this.lightBox.page_to_display.type;
        this.lightBox.click_open_page = this.lightBox.click_open_page.value;
        this.lightBox.page_to_display = this.lightBox.page_to_display.value;
        this.lightBox.is_one_time_display =
          this.lightBox.is_one_time_display.value;
        this.lightBox.is_mandatory = this.lightBox.is_mandatory.value;
        Object.keys(this.lightBox).map((key) => {
          if (this.lightBox[key] !== null) {
            lightBoxData.append(key, this.lightBox[key]);
          }
        });
        if (!this.isEdit) {
          this.isBtnLoading = true;
          GXPService.addLightBox(lightBoxData)
            .then((response) => {
              this.lightBoxs.push(response);
              this.submitted = false;
              this.isBtnLoading = false;
              this.addUpdateBox();
              Middleware.notification("Added successfully !!", "success", 1500);
            })
            .catch((error) => {
              this.submitted = false;
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          this.isBtnLoading = true;
          GXPService.updateLightBox(this.boxId, lightBoxData)
            .then((response) => {
              this.lightBoxs = this.lightBoxs.map((box) =>
                box.id == response.id ? (box = response) : box
              );
              this.submitted = false;
              this.isBtnLoading = false;
              this.addUpdateBox();
              Middleware.notification(
                "Updated successfully !!",
                "success",
                1500
              );
            })
            .catch((error) => {
              this.submitted = false;
              this.isBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
    // Method is used to change status
    changeStatus(id, data) {
      const lightBoxData = new FormData();
      lightBoxData.append("is_active", data.is_active);
      GXPService.updateLightBox(id, lightBoxData)
        .then(() => {
          Middleware.notification(
            "Status changed successfully !!",
            "success",
            1500
          );
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to handle update light box
    updateLightBox(box) {
      this.isEdit = true;
      this.addUpdateBox();
      this.boxId = box.id;
      this.lightBox.name = box.name;
      this.lightBox.after_second_display = box.after_second_display;
      this.lightBox.click_open_page_type = box.click_open_page_type;
      this.lightBox.click_open_page = this.openPageOptions.find(
        (item) => item.value == box.click_open_page
      );
      this.lightBox.page_to_display_type = box.page_to_display_type;
      this.lightBox.page_to_display = this.pageOptions.find(
        (item) => item.value == box.page_to_display
      );

      this.lightBox.is_mandatory = {
        text: box.is_mandatory == true ? "Yes" : "No",
        value: box.is_mandatory == true ? 1 : 0,
      };
      this.lightBox.is_one_time_display = {
        text: box.is_one_time_display == true ? "Yes" : "No",
        value: box.is_one_time_display == true ? 1 : 0,
      };
      this.lightBox.image = box.image;
    },
    // Method is used to delete light box
    deleteLightBox(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          try {
            await GXPService.deleteLightBox(id);
            this.lightBoxs = this.lightBoxs.filter((box) => box.id !== id);
          } catch (error) {
            errorHandler(error);
          }
        }
      });
    },

    // Method is used to add new light box
    addNewLightBox() {
      this.isEdit = false;
      this.isBoxDrawerOpen = true;
      this.resetData();
    },
    // Method is used to open and close drawer
    addUpdateBox() {
      if (!this.isBoxDrawerOpen) {
        this.resetData();
      }
      if (this.isBoxDrawerOpen) {
        this.openDropdown();
      }
      this.isBoxDrawerOpen = !this.isBoxDrawerOpen;
    },
    // Method is used to handle image change
    changeImage(event) {
      this.imgUrl = event !== undefined ? event[0] : null;
    },
    // Method is used to reset data
    resetData() {
      this.lightBox = {
        name: null,
        page_to_display: null,
        page_to_display_type: null,
        click_open_page: null,
        click_open_page_type: null,
        after_second_display: 0,
        is_one_time_display: 1,
        is_mandatory: 1,
        is_active: 1,
        image: null,
      };
      this.boxId = null;
      this.imgUrl = null;
      setTimeout(() => {
        if (document.querySelector(".has-icon") !== null) {
          document.querySelector(".has-icon").click();
        }
      }, 500);
    },
    // Method is used to open dropdown
    openDropdown(index) {
      if (index !== undefined) {
        if (this.isBoxDrawerOpen) {
          this.$refs.lightBoxDropdown[index].hide();
        } else {
          this.$refs.lightBoxDropdown[index].show();
        }
      }
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row" v-if="isLoading">
      <div class="col-md-3" v-for="no in 3" :key="no">
        <div class="placeholder-glow">
          <div class="mb-3 placeholder w-100 placeholder-lg light-box"></div>
        </div>
      </div>
    </div>
    <div class="row" v-if="!isLoading && lightBoxs.length !== 0">
      <div class="col-md-3" v-for="(box, index) in lightBoxs" :key="index">
        <div class="card p-2 mb-3">
          <p class="text-center font-weight-semibold mb-2">
            {{ box.name }}
          </p>
          <div
            class="light-box d-flex align-items-center justify-content-center"
            @click="openDropdown(index)"
          >
            <b-dropdown
              ref="lightBoxDropdown"
              class="mb-0 template-dropdown"
              toggle-class="btn btn-link text-muted"
              menu-class="dropdown-menu-end"
              right
              variant="white"
            >
              <template #button-content
                ><i class="mdi mdi-dots-vertical font-size-20"></i
              ></template>
              <b-dropdown-item href="#" @click="updateLightBox(box)"
                >Edit</b-dropdown-item
              >
              <b-dropdown-item href="#" @click="deleteLightBox(box.id)"
                >Delete</b-dropdown-item
              >
            </b-dropdown>
            <div>
              <img :src="box.image" alt="" class="d-block mx-auto" />
            </div>
          </div>
          <div
            class="form-check form-switch form-switch-md d-flex justify-content-center"
            @click="changeStatus(box.id, { is_active: !box.is_active })"
          >
            <input
              class="form-check-input"
              type="checkbox"
              id="active"
              v-model="box.is_active"
            />
          </div>
        </div>
      </div>
    </div>
    <Drawer
      @close="addUpdateBox"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="775"
    >
      <div v-if="isBoxDrawerOpen">
        <h4>{{ isEdit ? "Update" : "Add" }} Light Box</h4>
        <hr />
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <label for="">Name</label>
              <b-form-input
                id="name"
                type="text"
                placeholder="Light Box Name"
                autocomplete="off"
                v-model.trim="lightBox.name"
                :class="{
                  'is-invalid': submitted && $v.lightBox.name.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.lightBox.name.required">Name is required.</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label for="">time in second</label>
              <b-form-input
                id="time"
                value="13:45:00"
                type="number"
                placeholder="(In Second) time to display after page open"
                v-model="lightBox.after_second_display"
                v-mask="'####'"
              ></b-form-input>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label for="">which page you want to display</label>
              <MultiSelect
                v-model.trim="lightBox.page_to_display"
                :options="pageOptions"
                placeholder="Main Page"
                label="text"
                track-by="value"
                :show-labels="false"
                :allow-empty="false"
                :class="{
                  'is-invalid': submitted && $v.lightBox.page_to_display.$error,
                }"
              ></MultiSelect>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.lightBox.page_to_display.required"
                  >Page To Display is required.</span
                >
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label for="">onclick open</label>
              <MultiSelect
                v-model.trim="lightBox.click_open_page"
                :options="openPageOptions"
                placeholder="covid info"
                label="text"
                track-by="value"
                :show-labels="false"
                :allow-empty="false"
                :class="{
                  'is-invalid': submitted && $v.lightBox.click_open_page.$error,
                }"
              ></MultiSelect>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.lightBox.click_open_page.required"
                  >Click Open Page is required.</span
                >
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="d-block">Display onetime only </label>
              <MultiSelect
                v-model="lightBox.is_one_time_display"
                :options="[
                  {
                    text: 'Yes',
                    value: 1,
                  },
                  {
                    text: 'No',
                    value: 0,
                  },
                ]"
                placeholder="Display OneTime"
                label="text"
                track-by="value"
                :show-labels="false"
                :allow-empty="false"
              ></MultiSelect>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <label class="d-block">mandatory</label>
              <MultiSelect
                v-model="lightBox.is_mandatory"
                placeholder="Mandatory"
                :options="[
                  {
                    text: 'Yes',
                    value: 1,
                  },
                  {
                    text: 'No',
                    value: 0,
                  },
                ]"
                label="text"
                track-by="value"
                :show-labels="false"
                :allow-empty="false"
              ></MultiSelect>
            </div>
          </div>

          <div class="col-md-12">
            <div class="mb-3">
              <label for="">image</label>
              <div class="position-relative plus-icon">
                <VueDropify
                  message="Drop image or click here to select"
                  height="150px"
                  :src="lightBox.image"
                  @upload="changeImage($event)"
                  :class="{
                    'is-invalid': submitted && $v.lightBox.image.$error,
                  }"
                />
                <div v-if="submitted" class="invalid-feedback">
                  <span v-if="!$v.lightBox.image.required"
                    >Image is required.</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              @click="addUpdateBox"
            >
              Cancel
            </b-button>
            <b-button
              class="float-end"
              variant="outline-primary"
              type="submit"
              @click="onSubmit"
              :class="{
                disabled: isBtnLoading,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isBtnLoading"
              ></i>
              {{ isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </div>
    </Drawer>
  </div>
</template>

<style>
.light-box {
  height: 160px;
}
.light-box img {
  max-width: 100%;
  max-height: 150px;
}
.light-box-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.light-box-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 11;
  opacity: 1;
}
.light-box-overlay::before {
  content: "";
  background-color: black;
  opacity: 0.4;
  width: 100%;
  height: 540px;
  top: 0;
  position: absolute;
  z-index: 0;
}
</style>
